import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const ApmcSponsorRegPending = () => {
    const [selectedAction, setSelectedAction] = useState("All");
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
     const language = useSelector((state:any)=>state.auth.language);
  
      
      const statusOptions = [
          { value: "all_pending", label: "All Applications" , role:["MBA","MBMD", "DY", "DT","SA"] },
           { value: "pendingAtMBA", label: "Pending at  Marketing Board Administrator" , role:["MBA","MBMD", "DY", "DT","SA"] },
            { value: "pendingAtMBAResubmission", label: "Pending at  Marketing Board Administrator Resubmission" , role:["MBA","MBMD", "DY", "DT","SA"] },
             { value: "pendingAtMBMD", label: "Pending at Marketing Board Managing Director" , role:["MBA","MBMD", "DY", "DT","SA"] },
              { value: "pendingAtMBMDResubmission", label: "Pending at Marketing Board Managing Director Resubmission" , role:["MBA","MBMD", "DY", "DT","SA"] },

      ];

      const rolePriorityMap: Record<string, string> = {
  MBA:"all_pending",
  MBMD:"all_pending",
        DY:"all_pending",
        DT:"all_pending",

      };

      // Filter options for current role
      const filteredOptions = statusOptions.filter(option => option.role.includes(roleIdentifier));

      const firstOptionValue = rolePriorityMap[roleIdentifier] || filteredOptions[0]?.value;
      
      // Reorder the options to place the matched option first
      const reorderedStatusOptions = [
        filteredOptions.find(option => option?.value === firstOptionValue),
        ...filteredOptions.filter(option => option?.value !== firstOptionValue)
      ].filter(Boolean); 
      
   


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={reorderedStatusOptions} />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default ApmcSponsorRegPending;
